import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from 'src/app/models';
import { ApiService } from '../..';
import { ApiBasicService } from '../../api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class PublicApiServiceService {

  constructor(
    private api: ApiService,
    private apiBasic: ApiBasicService
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   generateLink(params: any): Observable<Res> {

    return this.api.post('createApiKey', params, 'private', 'npcapi');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.api.post('apiKeysList', params, 'private', 'npcapi');
  }

  /**
   * 
   */
   delete(params: any): Observable<Res> {
    
    return this.api.post('deleteApiKey', params, 'private', 'npcapi');
  }
}
